import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css";
import { Autocomplete, Avatar, Box, Button, FormControl, Grid, IconButton, LinearProgress, Pagination, Rating, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import profile from '../../assets/common/images/profile.png'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import { ArrowBackIos, ArrowDropDown, ArrowDropUp, ArrowOutward, BarChart, Business, CalendarViewMonth, Category, DonutLarge, EmojiEvents, NorthOutlined, QuestionMark, Schedule, SouthOutlined, Star, Translate, TrendingUp } from '@mui/icons-material';
import GroupReport from '../../Components/Charts/GroupReport';
import Footer from '../../Components/Footer/Footer';
import { ApiAldiGroupScore, ApiAldiRegionRanking, ApiComplimentReport, ApiDashboard, ApiGetCategoryHeatMap, ApiGetDashboardLowestScoringQuestions, ApiGetDashboardScoreByCategory, ApiGetDashboardScoreTrend, ApiGetDashboardStarRatingSummary, ApiGetGroupReport, ApiGetRecentReports, ApiGetScoreDistribution, ApiGetVenueAdminData, ApiGetVenueList, ApiRegionVenues, ApiVenuePerformance } from '../../apiService/Core/Apicall';
import { log } from 'console';
import chartlabel from '../../assets/images/styleimages/chartlabel.png'
import { useDispatch, useSelector } from 'react-redux';
import { Images } from '../../global/GloblImages';
import Domains from '../../global/constants/domain';
import { boolean } from 'yup';
import { RootState } from '../../global/config/store';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { setSelectedMonth } from '../../global/config/Reducer/MonthSlice';
import { RegionList, setRegion } from '../../global/config/Reducer/RegionSlice';
import storage from '../../utils/storage';
import DoubleLineChart from '../../Components/Charts/DoubleLineChart';
import TrendChart from '../../Components/Charts/TrendChart';
import DonutChart from '../../Components/Charts/DountChart';


const getIconColorByDomain = () => {
  const domain = window.location.hostname;

  if (domain.includes(Domains.ALDI)) return ['#1C2B9033', '#F96E091A', '#FFBF44', '#00B5DC'];       // Example: ALDI color
  if (domain.includes(Domains.BLOOMS)) return ['#1C2B9033'];     // Example: BLOOMS color
  if (domain.includes(Domains.MM)) return ['#E3DDD1'];         // Example: MM color

  return ['#E3DDD1'];
};
function VenueDashboard() {
  const chart_bgcolor = getIconColorByDomain()
  const domain = window.location.hostname
  const userData = JSON.parse(storage.getItem("userData") || "{}");
  const isAldi = domain.includes('aldi');
  const navigate = useNavigate()
  const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth)
  const dispatch = useDispatch()
  const [groupreport, setgroupreport] = useState<any>([])
  const [dashboard, setdashboard] = useState<any>([])
  const [venueperformance, setvenueperformance] = useState<any>([])
  const [venueAdminData, setvenueAdminData] = useState<any>([])
  const [RegionRanking, setRegionRanking] = useState<any>([])
  const [compliment, setcompliment] = useState<any>()
  const [searchParams] = useSearchParams();
  const venueId: any = searchParams.get('v');
  // const selectedMonth: any = searchParams.get('s');
  const venueName: any = searchParams.get('n');
  // const venueName:any = searchParams.get('n');
  const [reportyear, setreportyear] = useState<any>(dayjs(selectedMonth))
  const [month, setmonth] = useState<any>(dayjs(selectedMonth))
  const [scores, setScores] = useState<number[]>(new Array(12).fill(0));
  const [scores2, setScores2] = useState<number[]>(new Array(12).fill(0));
  const { m1, m2, m3, m4 } = Images()
  // const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)
  const clientEntity = storage.getItem('clientEntityId')
  const [venuelist, setvenuelist] = useState<any[]>([])
  const [venues, setvenues] = useState<number | string>(venueId)
  const Regions = useSelector(RegionList)
  const [selectedRegion, setselectedRegion] = useState<number | ''>(Regions[0]?.regionId ?? '')
  const [pages, setPages] = useState<any>({}); // { cardKey: pageNumber }
  const [data2, setData2] = useState<any>([])
  const [showLoading, setShowLoading] = useState<boolean>(false)
  const rowsPerPage = 5;
  const getPage = (key: any) => pages[key] || 1;

  const setPage = (key: string, pageNum: number) => {
    setPages((prev: any) => ({ ...prev, [key]: pageNum }));
  };
  const getTotalPages = (key: string, dataArr: any) => Math.ceil((dataArr?.length || 0) / rowsPerPage);

  const getPaginatedData = (key: string, dataArr: any) => {
    const currentPage = getPage(key);
    return (
      dataArr?.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
      ) || []
    );
  };
  console.log("Selected Report", selectedMonth)
  console.log("Selected Month", month)
  const monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  useEffect(() => {
    if (storage.getItem('userRole') === 'venueadmin') {
      setvenues(venuelist?.[0]?.venueId)
    }
  }, [venuelist])

  // console.group("Defaulet Month", selectedMonth)
  // console.group("Month", selectedmonth)
  // console.group("Month", month)
  // console.group("Month", reportyear)
  // console.group("Month", clientEntity)
  // console.log('Selected Month', selectedMonth)


  useEffect(() => {
    const getyearreport = async () => {
      console.log("Status ---->", reportyear)
      const data = `?year=${reportyear.year()}&clientEntityId=${storage.getItem('clientEntityId')}&isClientEntityIdRequired=true${venues ? `&venueId=${venues}` : ''}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
      const data2 = `?year=${reportyear.year()}&clientEntityId=${storage.getItem('clientEntityId')}&isClientEntityIdRequired=true${venues ? `&venueId=${venues}` : ''}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
      try {
        const response = (isAldi && storage.getItem('clientEntityName') !== 'Liquor ID') ? await ApiAldiGroupScore(data2) : await ApiGetGroupReport(data)
        isAldi && await AldiRegionRanking()

        setgroupreport(response.data)


        if (response?.data && isAldi && (storage.getItem('clientEntityName') !== 'Liquor ID')) {
          setScores([])
          setScores2([])
          const updatedScores = new Array(12).fill(0);
          const updatedScores2 = new Array(12).fill(0);
          response?.data?.complianceScore.map((item: any) => {
            const monthIndex = item.month - 1;
            updatedScores[monthIndex] = parseFloat(parseFloat(item.complianceScore).toFixed(2));
          });
          setScores(updatedScores);

          response?.data?.mystryShopeScore.map((item: any) => {
            const monthIndex = item.month - 1;
            updatedScores2[monthIndex] = parseFloat(parseFloat(item.mystryShopeScore).toFixed(2));
          });
          setScores2(updatedScores2);
        }
        else if (response.data) {
          const updatedScores = new Array(12).fill(0);
          response?.data.map((item: any) => {
            const monthIndex = item.reportMonth - 1;
            updatedScores[monthIndex] = parseFloat(parseFloat(item.avgScore).toFixed(2));
          });
          setScores(updatedScores);
        }
        // setgroupreport([response.data])
      }
      catch (error: any) {
        // toast.error(error)
        console.log("Error", error)
      }

    }
    reportyear && clientEntity && venues && getyearreport()

  }, [reportyear, venues, clientEntity])

  const venueAdmin = async () => {
    try {
      const data = `?clientEntityId=${storage.getItem('clientEntityId')}&isClientEntityIdRequired=true${venues ? `&venueId=${venues}` : ''}&month=${month.month() + 1}&year=${month.year()}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
      const res = await ApiGetVenueAdminData(data)
      setvenueAdminData(res.data)
    } catch (error) {

    }
  }

  useEffect(() => {
    (storage.getItem('userRole') === 'venueadmin' || venues) && venues && venueAdmin()
  }, [month, venues])


  const getDifferenceStyle = (difference: number | string | undefined | null) => {
    const value = Number(difference ?? 0);

    return {
      value: value.toFixed(2),
      color: value > -1 ? "var(--primary-color)" : "#BF613B",
      background: value > -1
        ? "var(--primary-light-main-color)"
        : "#BF613B1A",
    };
  };
  const getcomplimetreport = async () => {
    setcompliment([])
    try {
      const data = `?year=${month.year()}&clientEntityId=${storage.getItem('clientEntityId')}&isClientEntityIdRequired=true&month=${month.month() + 1}${venues ? `&venueId=${venues}` : ''}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
      const res = await ApiComplimentReport(data)
      if (res.data) {
        setcompliment(res.data)
      }
    } catch (error) {

    }
  }
  useEffect(() => {
    clientEntity && month && venues && getcomplimetreport()
  }, [clientEntity, venues, selectedMonth, month])


  const AldiRegionRanking = async () => {
    const data = `?year=${reportyear.year()}&clientEntityId=${storage.getItem('clientEntityId')}&isClientEntityIdRequired=true${venues ? `&venueId=${venues}` : ''}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
    try {
      const response = await ApiAldiRegionRanking(data)
      if (response.data) {
        setRegionRanking(response.data)
      }

    } catch (error: any) {
      // toast.error(error)
    }
  }

  useEffect(() => {
    const getapi = async () => {
      if (month && venueId) {
        setdashboard([])
        setvenueperformance([])
        try {
          // const data = {
          //   year: month.year(),
          //   month: month.month() + 1,
          //   clientEntityId: storage.getItem('clientEntityId'),
          //   ...(venues && {venueId:venues}),

          // }
          const data = `?month=${month.month() + 1}&year=${month.year()}&clientEntityId=${storage.getItem('clientEntityId')}&isClientEntityIdRequired=true${venues ? `&venueId=${venues}` : ''}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
          console.log(data)
          const response = await ApiDashboard(data)
          const response2 = await ApiVenuePerformance(data)
          setdashboard(response.data)
          setvenueperformance(response2)
          // toast.success(response2.message)
        }
        catch (error) {
          alert(error)
        }
      }
    }
    clientEntity && month && venues && getapi()
  }, [month, venues, selectedMonth, clientEntity])

  useEffect(() => {
    setreportyear(dayjs(selectedMonth))
    setmonth(dayjs(selectedMonth))
  }, [selectedMonth])


  useEffect(() => {
    const RegionList = async () => {
      if (storage.getItem("clientEntityId") && storage.getItem('ClientGroupName') === "ALDI") {
        const data = `?clientEntityId=${storage.getItem("clientEntityId")}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`

        const response3 = await ApiRegionVenues(data)
        dispatch(setRegion(response3.data))
      }
    }
    RegionList()
  }, [clientEntity])

  useEffect(() => {
    if (Regions.length > 0 && !selectedRegion) {
      setselectedRegion(Regions[0].regionId);
      setvenuelist(Regions[0].venues)
      // setvenues(Regions[0].venues[0].venueId)
    }
  }, [Regions, clientEntity]);

  useEffect(() => {
    const Venuelist = async () => {
      if (!window.location.hostname.includes('aldi')) {
        try {
          const clientEntityId: any = storage.getItem('clientEntityId')
          const response = await ApiGetVenueList(clientEntityId);
          console.log(response)
          setvenuelist(response.data);
          if (response.data.length > 0) {
            // setvenues(response.data[0].venueId)
          }
        } catch (error: any) {
          // toast.error(error)
        }
      }
      else {
        const finalregion = Regions && Regions.find((region: any) => region.regionId === selectedRegion)?.venues;
        setvenuelist(finalregion)
        if (finalregion && finalregion.length > 0) {
          // setvenues(finalregion[0].venueId)
        }

      }

    };
    clientEntity && Venuelist();

  }, [selectedRegion, clientEntity])


  const getScoreByCategory = async () => {
    try {
      const data = `?clientEntityId=${storage.getItem('clientEntityId')}&month=${month.month() + 1}&year=${month.year()}${venues ? `&venueId=${venues}` : ""}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ""}`
      const res = await ApiGetDashboardScoreByCategory(data)
      setData2((prev: any) => ({
        ...prev,
        sbc: res?.data,
      }));
    } catch (error: any) {
      toast.error(error?.message)
    }
  }

  const getScoreTrend = async () => {
    try {
      const data = `?clientEntityId=${storage.getItem('clientEntityId')}&month=${month.month() + 1}&year=${month.year()}${venues ? `&venueId=${venues}` : ""}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ""}`
      const res = await ApiGetDashboardScoreTrend(data)
      setData2((prev: any) => ({
        ...prev,
        st: res?.data,
      }));
    } catch (error: any) {
      toast.error(error?.message)
    }
  }
  const getScoreratingSummary = async () => {
    setShowLoading(true)
    try {
      const data = `?clientEntityId=${storage.getItem('clientEntityId')}&month=${month.month() + 1}&year=${month.year()}${venues ? `&venueId=${venues}` : ""}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ""}`
      const res = await ApiGetDashboardStarRatingSummary(data)
      setData2((prev: any) => ({
        ...prev,
        srs: res?.data,
      }));
    } catch (error: any) {
      toast.error(error?.message)
    }
    finally {
      setShowLoading(false)
    }
  }

  const getLowestScoringQuestions = async () => {
    try {
      const data = `?clientEntityId=${storage.getItem('clientEntityId')}&month=${month.month() + 1}&year=${month.year()}${venues ? `&venueId=${venues}` : ""}&isViewAll=false${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ""}`
      const res = await ApiGetDashboardLowestScoringQuestions(data)
      setData2((prev: any) => ({
        ...prev,
        lsq: res?.data,
      }));
    } catch (error: any) {
      toast.error(error?.message)
    }
  }
  const getCategoryHeatMap = async () => {
    try {
      const data = `?clientEntityId=${storage.getItem('clientEntityId')}&month=${month.month() + 1}&year=${month.year()}${venues ? `&venueId=${venues}` : ""}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ""}`
      const res = await ApiGetCategoryHeatMap(data)
      setData2((prev: any) => ({
        ...prev,
        chp: res?.data || [],
      }));
    } catch (error: any) {
      toast.error(error?.message)
    }
  }

  const getRecentReport = async () => {
    try {
      const data = `?clientEntityId=${storage.getItem('clientEntityId')}&month=${month.month() + 1}&year=${month.year()}${venues ? `&venueId=${venues}` : ""}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ""}`
      const res = await ApiGetRecentReports(data)
      setData2((prev: any) => ({
        ...prev,
        rr: res?.data || [],
      }));
    } catch (error: any) {
      toast.error(error?.message)
    }
  }

  const getScoreDistribution = async () => {
    try {
      const data = `?clientEntityId=${storage.getItem('clientEntityId')}&month=${month.month() + 1}&year=${month.year()}&isYTDScore=true${venues ? `&venueId=${venues}` : ""}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ""}`
      const res = await ApiGetScoreDistribution(data)
      setData2((prev: any) => ({
        ...prev,
        sd: res?.data || [],
      }));
    } catch (error: any) {
      toast.error(error?.message)
    }
  }

  useEffect(() => {
    getScoreByCategory()
    getScoreTrend()
    getScoreratingSummary()
    getLowestScoringQuestions()
    getCategoryHeatMap()
    getRecentReport()
    getScoreDistribution()
  }, [month, venues])


  const sbcPage = getPage('sbc');
  const sbcTotalPages = getTotalPages('sbc', data2?.sbc);
  const sbcPaginatedData = getPaginatedData('sbc', data2?.sbc);

  const lsqPage = getPage('lsq');
  const lsqTotalPages = getTotalPages('lsq', data2?.lsq);
  const lsqPaginatedData = getPaginatedData('lsq', data2?.lsq);


  const chpPage = getPage('chp');
  const chpTotalPages = getTotalPages('chp', data2?.chp);
  const chpPaginatedData = getPaginatedData('chp', data2?.chp);


  class ChartErrorBoundary extends React.Component<
    { name: string; children: React.ReactNode },
    { hasError: boolean }
  > {
    state = { hasError: false };

    static getDerivedStateFromError() {
      return { hasError: true };
    }

    componentDidCatch(error: Error) {
      console.error(`${this.props.name} crashed`, error);
    }

    render() {
      if (this.state.hasError) {
        return <div>{this.props.name} failed to render.</div>;
      }

      return this.props.children;
    }
  }

  return (
    <Box className='h-100 px-xl-3 pt-0 bg-white' height='fit-content'>
      <Box className='py-3 d-flex align-items-center justify-content-between'>
        <Typography className='fs-3 fw-bold'>{venueName}</Typography>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker sx={{ maxWidth: "120px" }} value={month} className='month-select  month-select2'
            views={['month', 'year']}
            format="MMM-YY"
            // onChange={(e:any) => { setmonth(e?.startOf('month')); }}
            onChange={(e: any) => {
              const isoString = e?.startOf('month').toISOString();
              dispatch(setSelectedMonth(isoString));
            }}
            slots={{
              openPickerIcon: ArrowDropDownIcon,
            }}
          />
        </LocalizationProvider>
      </Box>
      <Box className="row mb-3 gap-2 m-0 justify-content-between d-flex">
        <Grid container alignItems={'stretch'} spacing={2}>
          {/* ------------------------------------------------------- Customer Experience ----------------------------------------------------------- */}
          <Grid size={{ xs: 12, md: "grow" }}>
            <Box className="border-10  h-100 px-3 py-2" bgcolor={"var(--primary-color)"} border={'1px solid var(--primary-color)'}>
              <Box className='d-flex h-100 white-select align-items-center gap-2'>
                <Box className='d-flex flex-column align-items-end'>
                  <Box component='img' src={profile} maxWidth={'70px'} />
                </Box>
                <Box className='d-flex align-items-center gap-2'>
                  <Box>
                    <Typography className='fw-bold txt-white' fontSize={{ xs: '14px', md: '16px' }} gutterBottom>Customer Experience Score</Typography>
                    <Box className='d-flex align-items-baseline flex-wrap gap-2'>
                      <Typography className='mt-0 txt-white' fontWeight='900' fontSize={{ xs: '28px', md: '36px' }}>{dashboard ? parseFloat(dashboard?.currentMonth?.avgScore).toFixed(2) : '-/-'}%</Typography>
                      <Typography variant='body2' className='txt-white' whiteSpace={'nowrap'}>{Number(getDifferenceStyle(dashboard?.difference).value) > 0 ? <NorthOutlined sx={{ fontSize: '14px' }} /> : <SouthOutlined sx={{ fontSize: '14px' }} />}<span className='fw-bold'>{dashboard ? parseFloat(dashboard?.difference).toFixed(2) : '-/-'}%</span> from last month</Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
          {/* ------------------------------------------------------- Total Ratings ----------------------------------------------------------- */}
          <Grid size={{ xs: 12, md: "grow" }}>
            {
              storage.getItem('userRole') === 'venueadmin' || venues ?
                (<Box className="d-flex align-items-center h-100 px-3 py-0 gap-3 border-10 bg-secondary" >
                  <Box sx={{ background: '#FFFFFF1A' }} className='p-3' borderRadius={'50px'}>
                    <Business sx={{ fontSize: { xs: '36px', md: '52px' } }} className='text-white' />
                  </Box>
                  <Box>
                    <Typography className='fw-bold' whiteSpace='wrap'>Company Average Score</Typography>
                    <Typography fontSize={{ xs: '28px', md: '36px' }} fontWeight='900'>{(storage?.getItem("ISC") == "1" && storage.getItem('userRole') === 'venueadmin') ? "N/A" : parseFloat(venueAdminData?.companyAvgScore).toFixed(2)}</Typography>
                  </Box>

                </Box>
                ) :

                (compliment?.avgStarRating && storage.getItem('ratingJson')) ? (
                  <Box className="d-flex p-3 h-100 align-items-start justify-content-between border-10 bg-secondary">
                    {/* <Box component='img' src={avgrating} width={{ md: '20%', xs: '40%' }} /> */}
                    <Box className='d-flex align-items-center gap-3'>
                      <Box>
                        <Typography className='fw-bold' whiteSpace='wrap'>Star Rating Average</Typography>
                        <Typography fontSize={{ xs: '28px', md: '36px' }} fontWeight='900'>{compliment?.avgStarRating ?? '-/-'}</Typography>
                      </Box>
                      <Box sx={{ background: '#FFFFFF1A' }} className='p-3' borderRadius={'50px'}>
                        <Star sx={{ fontSize: { xs: '36px', md: '52px' } }} className='text-white' />
                      </Box>
                    </Box>
                    <IconButton onClick={() => { navigate('/maindashboard/reports/reportstarrating'); storage.setItem('ActiveTask', "Reports") }} className='p-2' sx={{ border: '1px solid black', borderRadius: '15px' }}>
                      <ArrowOutward />
                    </IconButton>
                  </Box>)
                  :
                  (<Box className="d-flex align-items-center h-100 px-3 py-0 gap-3 border-10 bg-secondary">
                    {/* <Box component='img' src={avgrating} width={{ md: '20%', xs: '40%' }} /> */}
                    <Box sx={{ background: '#FFFFFF1A' }} className='p-3' borderRadius={'50px'}>
                      <Business sx={{ fontSize: { xs: '36px', md: '52px' } }} className='text-white' />
                    </Box>
                    <Box>
                      <Typography className='fw-bold' whiteSpace='wrap'>{(storage.getItem('userRole') === "clientadmin" && !venues) ? "Company" : "Area"}<br /> Average (YTD)</Typography>
                      <Typography fontSize={{ xs: '28px', md: '36px' }} fontWeight='900'>{compliment?.companyYTDScore ?? '-/-'}</Typography>
                    </Box>
                  </Box>
                  )
            }
          </Grid>
          <Grid size={{ xs: 12, md: "grow" }}>
            {/* ------------------------------------------------------- Total Visits ----------------------------------------------------------- */}
            {storage.getItem('userRole') !== 'venueadmin' ?
              (
                <Box className="d-flex align-items-start h-100 p-3 justify-content-between border-10 bg-third">
                  <Box className='d-flex align-items-center gap-3'>
                    {/* <ArrowOutward /> */}
                    <Box sx={{ background: '#FFFFFF1A' }} className='p-3' borderRadius={'50px'}>
                      <EmojiEvents sx={{ fontSize: { xs: '36px', md: '52px' } }} className='text-white' />
                    </Box>
                    <Box>
                      <Typography className='fw-bold' whiteSpace='wrap'>Achieving {storage.getItem('ClientGroupName') === "TRANSPORT" ? "Networks" : 'Sites'}</Typography>
                      <Typography fontSize={{ xs: '28px', md: '36px' }} fontWeight='900'>{compliment?.compliantCount ?? '0'}/{compliment?.totalReports ?? '0'}</Typography>
                    </Box>
                  </Box>
                  <IconButton onClick={() => { navigate('/maindashboard/reports/groupmonthlysitescore'); storage.setItem('ActiveTask', "Reports") }} className='p-2' sx={{ border: '1px solid black', borderRadius: '15px' }}>
                    <ArrowOutward />
                  </IconButton>
                </Box>) :
              (<Box className="d-flex align-items-center h-100 px-3 py-0 gap-3 border-10 bg-third">
                <Box sx={{ background: '#FFFFFF1A' }} className='p-3' borderRadius={'50px'}>
                  <EmojiEvents sx={{ fontSize: { xs: '36px', md: '52px' } }} className='text-white' />
                </Box>
                <Box>
                  <Typography className='fw-bold' whiteSpace='wrap'>YTD Average Score</Typography>
                  <Typography fontSize={{ xs: '28px', md: '32px' }} fontWeight='900'>{venueAdminData?.ytdScore}</Typography>
                </Box>
              </Box>)}
          </Grid>
        </Grid>
      </Box>
      {/* --------------------------------------------------------------- middle Line ------------------------------------------ */}
      <Box className='d-flex flex-wrap my-3 mt-5 w-100  align-items-stretch' alignItems='stretch' gap={2}>
        {storage.getItem('clientEntityName') !== 'Liquor ID' &&
          ((storage.getItem('userRole') !== 'venueadmin' && !venues) ? (
            <Box position='relative' flex={1} height="100%" p={{ xs: 2, md: 3 }} className='d-flex border d-flex flex-column align-items-start justify-content-between h-100 border-10' gap={3}>
              <Typography>Top <br></br> Performing {storage.getItem('ClientGroupName') !== "TRANSPORT" && "Site"}</Typography>
              <Typography className='text-blue fw-bold'>{venueperformance?.topPerformingSite?.venueName ?? 'N/A'}</Typography>
              <Box component='img' position='absolute' top={-30} right={-10} src={m1} width={{ xs: '30%', md: '20%' }} maxWidth={'100px'}></Box>
            </Box>) :
            (storage.getItem("ISC") != "1" && (
              <Box position='relative' flex={1} height="100%" p={{ xs: 2, md: 3 }} className='d-flex border d-flex flex-column align-items-start justify-content-between h-100 border-10' gap={3}>
                <Typography>Last<br></br> Month Rank</Typography>
                <Typography className='text-blue fw-bold'>Your rank {venueAdminData?.monthlyRanking?.rank ?? 'N/A'} out of {venueAdminData?.monthlyRanking?.outOf > 0 ? venueAdminData?.monthlyRanking?.outOf : 'N/A'}</Typography>
                <Box component='img' position='absolute' top={-30} right={-10} src={m1} width={{ xs: '30%', md: '20%' }}></Box>
              </Box>)))}

        {storage.getItem('clientEntityName') !== 'Liquor ID' && (<Box position='relative' flex={1} height="100%" p={{ xs: 2, md: 3 }} className='d-flex  border  d-flex flex-column align-items-start justify-content-between h-100  border-10' gap={3}>
          <Typography className='w-25'>Biggest Opportunity</Typography>
          <Typography className='text-main fw-bold '>{venueperformance?.BottomPerformingCategory?.categoryName ?? 'N/A'}</Typography>
          <Box component='img' position='absolute' top={-30} right={-10} src={m2} width={{ xs: '40%', md: '20%' }} maxWidth={'100px'}></Box>
        </Box>)}
        {storage.getItem('clientEntityName') !== 'Liquor ID' &&
          ((storage.getItem('userRole') !== 'venueadmin' && !venues) ?
            (
              <Box position='relative' flex={1} height="100%" p={{ xs: 2, md: 3 }} className='d-flex border  d-flex flex-column align-items-start justify-content-between h-100  border-10' gap={3}>
                <Typography>Below <br></br> Benchmark {storage.getItem('ClientGroupName') !== "TRANSPORT" && "Site"}</Typography>
                <Typography className='text-blue fw-bold'>{venueperformance?.lowPerformingSite?.venueName ?? 'N/A'}</Typography>
                <Box component='img' position='absolute' top={-30} right={-10} src={m3} width={{ xs: '30%', md: '20%' }} maxWidth={'100px'} ></Box>
              </Box>) :
            (
              storage.getItem("ISC") != "1" && (<Box position='relative' flex={1} height="100%" p={{ xs: 2, md: 3 }} className='d-flex border  d-flex flex-column align-items-start justify-content-between h-100  border-10' gap={3}>
                <Typography>YTD<br></br>Rank</Typography>
                <Typography className='text-blue fw-bold'>Your rank {venueAdminData?.ytdRanking?.rank ?? '-'} out of {venueAdminData?.ytdRanking?.outOf ?? '-'}</Typography>
                <Box component='img' position='absolute' top={-30} right={-10} src={m3} width={{ xs: '30%', md: '20%' }} maxWidth={'100px'}></Box>
              </Box>)))}

        {storage.getItem('clientEntityName') !== 'Liquor ID' && (<Box position='relative' flex={1} height="100%" p={{ xs: 2, md: 3 }} className='d-flex border  d-flex flex-column align-items-start justify-content-between h-100 border-10' gap={3}>
          <Typography>Your <br></br> Biggest Strength</Typography>
          <Typography className='text-main fw-bold'>{venueperformance?.TopPerformingCategory?.categoryName ?? 'N/A'}</Typography>
          <Box component='img' position='absolute' top={-30} right={-10} src={m4} width={{ xs: '30%', md: '20%' }} maxWidth={'100px'}></Box>
        </Box>)}
      </Box>

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: (storage.getItem('ClientGroupName') == "JBHIFI" || storage.getItem('ClientGroupName') == "MM" || storage.getItem('ClientGroupName') == "EXTENDED" ? 6 : 12), xl: ((storage.getItem('ClientGroupName') == "JBHIFI" || storage.getItem('ClientGroupName') == "MM" || storage.getItem('ClientGroupName') == "EXTENDED") ? 6 : 4) }}>
          <Box className='border d-flex flex-column border-main border-10 h-100 overflow-hidden'>
            <Grid container alignItems={'center'} className='p-3 mm-card-gradient' justifyContent={'space-between'}>
              <Grid size={'auto'}>
                <Box className='d-flex align-items-center gap-2'>
                  <Box className='p-1 border-10 bg-main'>
                    <Category className='text-white' />
                  </Box>
                  <Typography className='text-dark fw-bold'>Score by Category</Typography>
                </Box>
              </Grid>
              <Grid size={'auto'}>
                <Box className='d-flex align-items-center gap-3'>
                  <Box className='d-flex align-items-center gap-1'>
                    <Box className='bg-main' height={'8px'} width={'8px'} borderRadius={'10px'}></Box>
                    <Typography variant='caption' className='text-dark'>Your Score</Typography>
                  </Box>
                  <Box className='d-flex align-items-center gap-1'>
                    <Box className='bg-secondary' height={'8px'} width={'8px'} borderRadius={'10px'}></Box>
                    <Typography variant='caption' className='text-dark'>Company Avg</Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
            <Box flex={1} className='p-3 d-flex flex-column'>
              {sbcPaginatedData?.length > 0 ? (
                <Box flex={1}>
                  {
                    sbcPaginatedData?.map((item: any, index: number) => (
                      <Box className='mb-3'>
                        <Grid container alignItems={'center'} spacing={2} className='w-100'>
                          <Grid size={4}>
                            <Typography variant='body2' className='text-dark'>{item?.categoryName}</Typography>
                          </Grid>
                          <Grid size={'grow'}>
                            <Box className='w-100'>
                              <Box className='d-flex align-items-center gap-2'>
                                <Box flex={1}>
                                  <LinearProgress
                                    variant="determinate"
                                    value={item?.venueScore || 0}
                                    aria-label="Export data"
                                    sx={{
                                      height: 10,
                                      borderRadius: 5,
                                      backgroundColor: "var(--primary-light-main-color)",
                                      "& .MuiLinearProgress-bar": {
                                        background: "var(--primary-color)",
                                        borderRadius: 5,
                                      },
                                    }}
                                  />
                                </Box>
                                <Typography className='d-block m-0 p-0 text-dark' variant='caption'>{item?.venueScore}%</Typography>
                              </Box>
                              <Box className='d-flex align-items-center gap-2'>
                                <Box flex={1}>
                                  <LinearProgress
                                    className='mt-1'
                                    variant="determinate"
                                    value={item?.businessScore || 0}
                                    aria-label="Export data"
                                    sx={{
                                      height: 10,
                                      borderRadius: 5,
                                      backgroundColor: "var(--secondary-light-color)",
                                      "& .MuiLinearProgress-bar": {
                                        background: "var(--secondary-color)",
                                        borderRadius: 5,
                                      },
                                    }}
                                  />
                                </Box>
                                <Typography className='d-block m-0 p-0 text-dark' variant='caption'>{item?.businessScore}%</Typography>
                              </Box>

                            </Box>
                          </Grid>
                          <Grid size={2} className='d-flex justify-content-end'>
                            <Typography className='fw-bold' variant='caption'>{Number(getDifferenceStyle(item?.change).value) > 0 ? <ArrowDropUp sx={{ color: getDifferenceStyle(item?.change).color }} /> : <ArrowDropDown sx={{ color: getDifferenceStyle(item?.change).color }} />}<span style={{ color: getDifferenceStyle(item?.change).color }} className='fw-bold'>{item?.change}%</span></Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    ))
                  }

                </Box>
              ) : (
                <Box className='d-flex h-100 align-items-center justify-content-center'><Typography>No Data Found</Typography></Box>)}
              {sbcTotalPages > 1 ? (
                <Box display="flex" justifyContent="center" mt={2}>
                  <Pagination
                    page={sbcPage}
                    sx={{
                      "& .MuiPaginationItem-root.Mui-selected": {
                        backgroundColor: 'var(--primary-color)'
                      }
                    }}
                    count={sbcTotalPages}
                    color="primary"
                    onChange={(_, value) => setPage('sbc', value)}
                  />
                </Box>
              ) : ("")}
            </Box>
          </Box>
        </Grid>
        {(storage.getItem('ClientGroupName') == "JBHIFI" || storage.getItem('ClientGroupName') == "MM" || storage.getItem('ClientGroupName') == "EXTENDED") && (
          <Grid size={{ xs: 12, md: 6, xl: 6 }}>
            <Box className='border d-flex flex-column border-main border-10 h-100 overflow-hidden'>
              <Box className='d-flex align-items-center justify-content-between p-3 mm-card-gradient'>
                <Box className='d-flex align-items-center gap-2'>
                  <Box className='p-1 border-10 bg-main'>
                    <Star className='text-white' />
                  </Box>
                  <Typography className='text-dark fw-bold m-0 p-0'>Star Ratings Summary</Typography>
                </Box>
                {JSON.parse(storage?.getItem('userOtherData') || "{}")?.venueCanSeeStarRating ? (<Link to={'/maindashboard/reports/reportstarrating'} className='text-main'>View All</Link>) : (<></>)}
              </Box>
              <Box flex={1} className='p-3 pt-0'>
                {showLoading ? (
                  <Box className='h-100 d-flex align-items-center justify-content-center'><Typography>Preparing your star rating and industry comparison…</Typography></Box>
                ) :
                  data2?.srs?.length > 0 ? (
                    <Box>
                      <Grid container alignItems={'center'} sx={{
                        position: "relative",
                        "&::after": {
                          content: '""',
                          position: "absolute",
                          left: 0,
                          right: 0,
                          bottom: 0,
                          height: "1px",
                          background: `repeating-linear-gradient(
                              to right,
                             #00000040 0px,
                             #00000040 12px,
                          transparent 12px,
                          transparent 20px
                          )`,
                        }, py: '12px',
                        marginBottom: '15px'
                      }} spacing={2}>
                        <Grid size={4}>
                          <Typography variant='caption' className='text-blue fw-bold m-0 p-0'>Category Name</Typography>
                        </Grid>
                        <Grid size={3}>
                          <Typography variant='caption' className='text-blue fw-bold m-0 p-0'>Ratings</Typography>
                        </Grid>
                        <Grid size='grow' className='d-flex align-items-center gap-1'><Typography variant='caption' className='text-dark fw-bold text-blue text-center m-0 p-0'></Typography></Grid>
                        <Grid size='grow' className='d-flex align-items-center gap-1'><Typography variant='caption' className='text-dark text-blue fw-bold text-center m-0 p-0'>Com. Avg</Typography></Grid>
                        <Grid size='grow' className='d-flex align-items-center gap-1'><Typography variant='caption' className='text-dark text-blue fw-bold text-center m-0 p-0'>Ind. Avg</Typography></Grid>
                        <Grid size='grow'><Typography variant='caption' className='text-dark fw-bold text-blue text-center m-0 p-0'>Change</Typography></Grid>
                      </Grid>
                      {
                        data2?.srs?.map((item: any) => (
                          <Box className='mb-3'>
                            <Grid container alignItems={'center'} spacing={2}>
                              <Grid size={4}>
                                <Typography variant='body2' className='text-dark m-0 p-0'>{item?.categoryName}</Typography>
                              </Grid>
                              <Grid size={3}>
                                <Rating name="half-rating" sx={{ flex: 1, color: 'var(--primary-color)' }} className='m-0 p-0' defaultValue={item?.venueScore} readOnly />
                              </Grid>
                              <Grid size='grow' className='d-flex align-items-center gap-1'><Box className='bg-main' height={'8px'} width={'8px'} borderRadius={'10px'}></Box><Typography variant='body2' className='text-dark text-center m-0 p-0'>{item?.venueScore}</Typography></Grid>
                              <Grid size='grow' className='d-flex align-items-center gap-1'><Box className='bg-secondary' height={'8px'} width={'8px'} borderRadius={'10px'}></Box><Typography variant='body2' className='text-dark text-center m-0 p-0'>{item?.businessScore}</Typography></Grid>
                              <Grid size='grow' className='d-flex align-items-center gap-1'><Box className='bg-third' height={'8px'} width={'8px'} borderRadius={'10px'}></Box><Typography variant='body2' className='text-dark text-center m-0 p-0'>{item?.industryAverage}</Typography></Grid>
                              <Grid size='grow'><Typography variant='body2' className='text-dark text-center m-0 p-0 fw-bold' sx={{ color: `${getDifferenceStyle(item?.change).color} !important` }}> {item?.change > 0 ? "+" : ""}{item?.change}</Typography></Grid>
                            </Grid>
                          </Box>
                        ))
                      }
                    </Box>
                  ) : (
                    <Box className='h-100 d-flex align-items-center justify-content-center'><Typography>No Data Found</Typography></Box>
                  )}
              </Box>
            </Box>
          </Grid>
        )}
        <Grid size={{ xs: 12, md: (storage.getItem('ClientGroupName') == "JBHIFI" || storage.getItem('ClientGroupName') == "MM" || storage.getItem('ClientGroupName') == "EXTENDED" ? 6 : 6), xl: ((storage.getItem('ClientGroupName') == "JBHIFI" || storage.getItem('ClientGroupName') == "MM" || storage.getItem('ClientGroupName') == "EXTENDED") ? 6 : 4) }}>
          <Box className='border h-100 border-main border-10 overflow-hidden'>
            <Box className='d-flex align-items-center justify-content-between mm-card-gradient mb-2 p-3'>
              <Box className='d-flex align-items-center gap-2'>
                <Box className='p-1 border-10 bg-main'>
                  <DonutLarge className='text-white' />
                </Box>
                <Typography className='text-dark fw-bold'>Score Distribution</Typography>
                <Typography className='text-dark' variant='caption'>All reports YTD</Typography>
              </Box>
            </Box>
            {data2?.sd?.distribution?.length > 0 && (
              <Box className='p-3'>
                <DonutChart data2={data2?.sd} />
              </Box>
            )}
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: (storage.getItem('ClientGroupName') == "JBHIFI" || storage.getItem('ClientGroupName') == "MM" || storage.getItem('ClientGroupName') == "EXTENDED" ? 6 : 6), xl: ((storage.getItem('ClientGroupName') == "JBHIFI" || storage.getItem('ClientGroupName') == "MM" || storage.getItem('ClientGroupName') == "EXTENDED") ? 6 : 4) }}>
          <Box className='border border-main border-10 overflow-hidden'>
            <Box className='d-flex align-items-center p-3 mm-card-gradient justify-content-between mb-2'>
              <Box className='d-flex align-items-baseline gap-1'>
                <Box className='p-1 border-10 bg-main'>
                  <TrendingUp className='text-white' />
                </Box>
                <Typography className='text-dark fw-bold'>Score Trend</Typography>
                <Typography className='text-dark' variant='caption'>(Last 6 Months)</Typography>
              </Box>
              <Box className='d-flex align-items-center gap-2'>
                <Box className='d-flex align-items-center gap-1'>
                  <Box className='bg-main' height={'8px'} width={'8px'} borderRadius={'10px'}></Box>
                  <Typography variant='caption' className='text-dark'>Your Score</Typography>
                </Box>
                <Box className='d-flex align-items-center gap-1'>
                  <Box className='bg-secondary' height={'8px'} width={'8px'} borderRadius={'10px'}></Box>
                  <Typography variant='caption' className='text-dark'>Company Avg</Typography>
                </Box>
              </Box>
            </Box>
            <Box className='p-3'>
              {data2?.st && (<DoubleLineChart data={data2?.st} />)}
            </Box>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 12, xl: 12 }}>
          <Box className="border d-flex flex-column border-main border-10 h-100 overflow-hidden">
            <Box className='d-flex align-items-center justify-content-between p-3 mm-card-gradient'>
              <Box className="d-flex gap-2">
                <Box className='p-1 border-10 bg-main'>
                  <QuestionMark className='text-white' />
                </Box>
                <Typography className="fw-bold text-dark fw-bold">
                  Lowest Scoring Questions
                </Typography>
              </Box>
              <Link to={'/maindashboard/reports/questionsummaryreport'} className='text-main'>View All</Link>
            </Box>
            <Box flex={1} className='p-3 pt-0'>
              {lsqPaginatedData?.length > 0 ? (
                <Table size="small" className='m-0 p-0'>
                  <TableHead sx={{
                    position: "relative",
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      left: 0,
                      right: 0,
                      bottom: 0,
                      height: "1px",
                      background: `repeating-linear-gradient(
                              to right,
                             #00000040 0px,
                             #00000040 12px,
                          transparent 12px,
                          transparent 20px
                          )`,
                    },


                  }}>
                    <TableRow>
                      <TableCell className='m-0' sx={{ py: 3.8 }}></TableCell>
                      <TableCell className='fw-bold m-0'><Typography variant='caption' className='fw-bold text-blue'>Question</Typography></TableCell>
                      <TableCell className='fw-bold m-0'><Typography variant='caption' className='fw-bold text-blue'>Category</Typography></TableCell>
                      <TableCell className='fw-bold m-0'><Typography variant='caption' className='fw-bold text-blue'>Your Score</Typography></TableCell>
                      <TableCell className='fw-bold m-0'><Typography variant='caption' className='fw-bold text-blue'>Company Avg</Typography></TableCell>
                      <TableCell className='fw-bold m-0'><Typography variant='caption' className='fw-bold text-blue'>Gap</Typography></TableCell>
                      {storage.getItem('ClientGroupName') != "BLOOMS" && (<TableCell className='fw-bold m-0'><Typography variant='caption' className='fw-bold text-blue'>Trend</Typography></TableCell>)}
                    </TableRow>
                  </TableHead>

                  <TableBody >
                    {lsqPaginatedData?.map((row: any, index: number) => (
                      <TableRow key={row?.question}>
                        <TableCell>
                          <Typography variant='body1' className='fw-bold'>{index + 1}</Typography>
                        </TableCell>
                        <TableCell><Tooltip title={row?.question || ""} arrow>
                          <Typography
                            variant="body2"
                            sx={{
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              lineHeight: 1.5,
                              maxHeight: "3em", // 2 × 1.5em
                              width: "100%",
                              maxWidth: { lg: 450, xl: 600 },
                            }}
                          >
                            {row?.question}
                          </Typography>
                        </Tooltip>
                        </TableCell>
                        <TableCell><Typography variant='body2'>{row?.categoryName}</Typography></TableCell>
                        <TableCell><Typography variant='body2'>{row?.venuePercentage}%</Typography></TableCell>
                        <TableCell><Typography variant='body2'>{row?.businessPercentage}%</Typography></TableCell>
                        <TableCell>
                          <Typography sx={{ color: `${getDifferenceStyle(row?.gap).color} !important` }} className='fw-bold' variant='body2'>
                            {row?.gap > 0 ? "+" : ""}{row.gap}%
                          </Typography>
                        </TableCell>
                        {storage.getItem('ClientGroupName') != "BLOOMS" && (<TableCell>{row?.trend && (<Box maxWidth={'100px'}> <TrendChart trend={row?.trend} /></Box>)}</TableCell>)}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <Box className='h-100 d-flex align-items-center justify-content-center'><Typography>No Data Found</Typography></Box>
              )}
              {lsqTotalPages > 1 ? (
                <Box display="flex" justifyContent="center" mt={2}>
                  <Pagination
                    page={lsqPage}
                    sx={{
                      "& .MuiPaginationItem-root.Mui-selected": {
                        backgroundColor: 'var(--primary-color)'
                      }
                    }}
                    count={lsqTotalPages}
                    color="primary"
                    onChange={(_, value) => setPage('lsq', value)}
                  />
                </Box>
              ) : ("")}
            </Box>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 6, xl: 6 }}>
          <Box className="border d-flex flex-column border-main border-10 h-100 overflow-hidden">
            <Box className="d-flex gap-1 align-items-center p-3 mm-card-gradient justify-content-between">
              <Box className='d-flex align-items-baseline gap-2'>
                <Box className='p-1 border-10 bg-main'>
                  <CalendarViewMonth className='text-white' />
                </Box>
                <Typography className="fw-bold text-dark">
                  Category Heatmap
                </Typography>

                <Typography variant="caption" className='text-dark'>
                  (Last 6 Months)
                </Typography>
              </Box>
              <Box>
                <Box className="d-flex gap-3 justify-content-end">
                  <Box className='d-flex align-items-center gap-1'>
                    <Box height={'15px'} width={'15px'} borderRadius={'50%'} bgcolor={"var(--primary-color)"}></Box>
                    <Typography variant="caption">
                      90-100%
                    </Typography>
                  </Box>
                  <Box className='d-flex align-items-center gap-1'>
                    <Box height={'15px'} width={'15px'} borderRadius={'50%'} bgcolor={"var(--secondary-color)"}></Box>
                    <Typography variant="caption">
                      81-89%
                    </Typography>
                  </Box>
                  <Box className='d-flex align-items-center gap-1'>
                    <Box height={'15px'} width={'15px'} borderRadius={'50%'} bgcolor={"var(--third-color)"}></Box>
                    <Typography variant="caption">
                      Below 80%
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box flex={1} className='p-3 d-flex flex-column'>

              {chpPaginatedData?.length > 0 ? (
                <Box flex={1}>
                  <Table className='p-0' sx={{
                    borderCollapse: "separate",
                    borderSpacing: "5px 5px",
                  }} size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell className='border-0' />
                        {
                          data2?.chp?.[0]?.trend?.map((item: any) => (
                            <TableCell className='p-1 text-center'><Typography variant='body2'>{monthNames[item?.month - 1]}</Typography></TableCell>
                          ))
                        }
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {chpPaginatedData?.map((item: any, index: number) => (
                        <TableRow key={index} sx={{ alignItems: 'center' }}>
                          <TableCell className='border-0 p-1'>{item?.categoryName}</TableCell>
                          {item?.trend.map((value: any, i: number) => (
                            <TableCell
                              key={i}
                              className='border-10 border-0 p-1'
                              sx={{
                                background:
                                  value?.venueScore >= 90
                                    ? "var(--primary-color)"
                                    : value?.venueScore >= 81
                                      ? "var(--secondary-color)"
                                      : "var(--third-color)",
                                color:
                                  value?.venueScore >= 90
                                    ? "#FFFFFF"
                                    : value?.venueScore >= 80
                                      ? "#FFFFFF"
                                      : value?.venueScore >= 70 ? "#FFFFFF" : "#FFFFFF",
                                textAlign: "center",
                                fontWeight: 600,
                              }}
                            >
                              {value?.venueScore}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              ) : (<Box className='h-100 d-flex align-items-center justify-content-center'>No Data Found</Box>)}
              {chpTotalPages > 1 ? (
                <Box display="flex" justifyContent="center" mt={2}>
                  <Pagination
                    page={chpPage}
                    sx={{
                      "& .MuiPaginationItem-root.Mui-selected": {
                        backgroundColor: 'var(--primary-color)'
                      }
                    }}
                    count={chpTotalPages}
                    color="primary"
                    onChange={(_, value) => setPage('chp', value)}
                  />
                </Box>
              ) : ("")}
            </Box>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 6, xl: 6 }}>
          <Box className="border d-flex flex-column border-main border-10 h-100 overflow-hidden">
            <Box className='d-flex align-items-center justify-content-between p-3 mm-card-gradient'>
              <Box className="d-flex gap-2 align-items-center">
                <Box className='p-1 border-10 bg-main'>
                  <Schedule className='text-white' />
                </Box>
                <Typography className="fw-bold text-dark ">
                  Recent Reports
                </Typography>
              </Box>
              <Link to={'/maindashboard/scoreCard'} className='text-main'>View All</Link>
            </Box>
            <Box flex={1} className='p-3'>
              {
                data2?.rr?.length > 0 ? (

                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell><Typography variant='body2'>Date</Typography></TableCell>
                        <TableCell className='text-center'><Typography variant='body2'>Final Score</Typography></TableCell>
                        <TableCell className='text-center'><Typography variant='body2'>Average Score</Typography></TableCell>
                        <TableCell className='text-center'><Typography variant='body2'>Change</Typography></TableCell>
                        <TableCell className='text-center'><Typography variant='body2'>Rank</Typography></TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {data2?.rr?.map((item: any, index: number) => (
                        <TableRow key={index}>
                          <TableCell className='py-2'><Typography variant='body2' className='fw-bold'>{monthNames[item?.month - 1]}, {item?.year}</Typography></TableCell>

                          <TableCell className='py-2 text-center'><Typography variant='body2' className='fw-bold'>{item.venueScore}</Typography></TableCell>
                          <TableCell className='py-2 text-center'><Typography variant='body2' className='fw-bold'>{item.businessScore}</Typography></TableCell>

                          <TableCell className='py-2 text-center'>
                            <Typography
                              variant='body2'
                              color={
                                item.change >= 0
                                  ? "success.main"
                                  : "error.main"
                              }
                            >
                              {item.change}
                            </Typography>
                          </TableCell>

                          <TableCell className='text-center'><Typography variant='body2'>{item.rank}/{item?.outOf}</Typography></TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <Box className='d-flex align-items-center justify-content-center'><Typography>No Data Found</Typography></Box>
                )}
            </Box>
          </Box>
        </Grid>
      </Grid>
      {/* ------------------------------------------------------------ Group Report -------------------------------------------- */}
      {(
        <>
          <Box className='d-flex align-items-center gap-2 my-3 flex-wrap'>
            <Box position='relative' maxWidth='100%' flex={1} className='border-10 border  p-2 pb-3'>
              <Box className="d-flex px-2 mb-0 justify-content-between align-items-center">
                <Box className="text-left d-flex align-items-center gap-2" width={{ xs: '15%' }}>
                  <Box className='p-1 border-10 bg-main'>
                    <BarChart className='text-white' />
                  </Box>
                  <Typography fontWeight='bold' whiteSpace={{ xs: 'nowrap' }} className="font-bold" >{domain.includes('aldi') ? 'Compliance' : storage.getItem('userRole') === 'venueadmin' ? `${userData?.displayName} Group Report` : 'Your Group Report'} </Typography>
                </Box>
                <Box width={{ xs: '75%', md: 'auto' }} className="d-flex align-items-end  justify-content-end">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker value={reportyear} className='month-select'
                      views={['year']}
                      format="YYYY"
                      onChange={(e: any) => { setreportyear(e?.startOf('year')); }}
                      maxDate={dayjs()}
                      slots={{
                        openPickerIcon: ArrowDropDownIcon, // Replaces calendar icon
                      }}
                    />
                  </LocalizationProvider>
                </Box>
              </Box>
              {groupreport ? (<> <GroupReport diffbarcolor={false} totalheight={325} barWidth={40} horizontal={false} xAxis={monthNames} yAxis={scores} />
                {/* <Box

              sx={{
                position: 'absolute',
                bottom: '-10px',
                left: '50%',
                transform: 'translate(-50%, 0%)',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Box
                px={5}
                sx={{ backgroundImage: `url(${chartlabel})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat' }}
              >
                <Typography variant='caption' whiteSpace='nowrap'>
                  X-Axis: Months | Y-Axis: Ratings
                </Typography>
              </Box>
            </Box> */}
              </>)
                : <Typography className='text-center my-5' variant='h5'>No Data Found</Typography>}
            </Box>

            {window.location.hostname.includes(Domains.ALDI) && storage.getItem('clientEntityName') !== 'Liquor ID' && (<Box position='relative' maxWidth='100%' flex={1} bgcolor={chart_bgcolor[1]} my={{ xs: 2, md: 0 }} className='border-10   p-2 pb-3'>
              <Box className="d-flex px-2 mb-0 justify-content-between align-items-center">
                <Box className="text-left" width={{ xs: '15%' }}>
                  <Typography fontSize={{ md: '20px', xs: '14px' }} fontWeight='bold' whiteSpace={{ xs: 'nowrap' }} className="font-bold">Moments that matter</Typography>
                </Box>
                <Box width={{ xs: '75%', md: 'auto' }} className="d-flex align-items-end  justify-content-end">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker value={reportyear} className='month-select'
                      views={['year']}
                      format="YYYY"
                      onChange={(e: any) => { setreportyear(e?.startOf('year')); }}
                      maxDate={dayjs()}
                      slots={{
                        openPickerIcon: ArrowDropDownIcon, // Replaces calendar icon
                      }}
                    />
                  </LocalizationProvider>
                </Box>
              </Box>

              {groupreport ? (<><GroupReport diffbarcolor={true} totalheight={325} barWidth={40} horizontal={false} xAxis={monthNames} yAxis={scores2} />
                {/* <Box

                  sx={{
                    position: 'absolute',
                    bottom: '0px',
                    left: '50%',
                    transform: 'translate(-50%, 0%)',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Box
                    px={5}
                    sx={{ backgroundImage: `url(${chartlabel})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat' }}
                  >
                    <Typography variant='caption' whiteSpace='nowrap'>
                      X-Axis: Months | Y-Axis: Ratings
                    </Typography>
                  </Box>
                </Box>  */}
              </>
              ) : <Typography className='text-center my-5' variant='h5'>No Data Found</Typography>}
            </Box>)}
          </Box>

          {window.location.hostname.includes(Domains.ALDI) && storage.getItem('clientEntityName') !== 'Liquor ID' && (
            <Box className='d-flex mt-2 align-items-stretch flex-wrap' gap={{ xs: 3, md: 2 }}>
              <Box position='relative' flex={1} maxWidth='100%' bgcolor={`${chart_bgcolor[2]}1A`} className='border-10  p-2 pb-3'>
                <Box className="d-flex px-2 mb-0 justify-content-between align-items-center">
                  <Box className="text-left" width={{ xs: '15%' }}>
                    <Typography fontSize={{ md: '20px', xs: '14px' }} fontWeight='bold' whiteSpace={{ xs: 'nowrap' }} className="font-bold" >Region Ranking Compliance</Typography>
                  </Box>
                  <Box width={{ xs: '75%', md: 'auto' }} className="d-flex align-items-end  justify-content-end">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker value={reportyear} className='month-select'
                        views={['year']}
                        format="YYYY"
                        onChange={(e: any) => { setreportyear(e?.startOf('year')); }}
                        maxDate={dayjs()}
                        slots={{
                          openPickerIcon: ArrowDropDownIcon, // Replaces calendar icon
                        }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Box>
                {RegionRanking ? RegionRanking?.complianceScore?.map((item: any, index: number) =>
                (
                  <Box key={index} className='d-flex px-2 mt-3 align-items-center justify-content-between mb-3 gap-2'>
                    <Box width='5%'>
                      <Typography fontSize='14px' className='text-main'>{item?.regionName}</Typography>
                    </Box>
                    <Box className='d-flex gap-2' width={{ xs: '75%', md: '100%' }}>
                      <div className="custom-progress-bar">
                        <div className="progress-fill" style={{ width: `${item?.compliancefinalScore}%`, backgroundColor: `${chart_bgcolor[2]}` }}></div>
                      </div>
                      <Typography fontWeight={900} width='7%'>{item?.compliancefinalScore}%</Typography>
                    </Box>

                  </Box>
                )
                ) : <Typography className='text-center my-5' variant='h5'>No Data Found</Typography>}

              </Box>

              <Box position='relative' flex={1} maxWidth='100%' bgcolor={`${chart_bgcolor[3]}1A`} className='border-10  p-2 pb-3'>
                <Box className="d-flex px-2 mb-0 justify-content-between align-items-center">
                  <Box className="text-left" width={{ xs: '15%' }}>
                    <Typography fontSize={{ md: '20px', xs: '14px' }} fontWeight='bold' whiteSpace={{ xs: 'nowrap' }} className="font-bold" >Region Ranking Moments that matter</Typography>
                  </Box>
                  <Box width={{ xs: '75%', md: 'auto' }} className="d-flex align-items-end  justify-content-end">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker value={reportyear} className='month-select'
                        views={['year']}
                        format="YYYY"
                        onChange={(e: any) => { setreportyear(e?.startOf('year')); }}
                        maxDate={dayjs()}
                        slots={{
                          openPickerIcon: ArrowDropDownIcon, // Replaces calendar icon
                        }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Box>
                {RegionRanking ? RegionRanking?.mystryShopeScore?.map((item: any, index: number) =>
                (
                  <Box key={index} className='d-flex px-2 mt-3 align-items-center justify-content-between mb-3 gap-2'>
                    <Box width='5%'>
                      <Typography fontSize='14px' className='text-main'>{item?.regionName}</Typography>
                    </Box>
                    <Box className='d-flex gap-2' width={{ xs: '75%', md: '100%' }}>
                      <div className="custom-progress-bar">
                        <div className="progress-fill" style={{ width: `${item?.mystryShopeScore}%`, backgroundColor: `${chart_bgcolor[3]}` }}></div>
                      </div>
                      <Typography fontWeight={900} width='7%'>{item?.mystryShopeScore}%</Typography>
                    </Box>

                  </Box>
                )
                ) : <Typography className='text-center my-5' variant='h5'>No Data Found</Typography>}

              </Box>

            </Box>
          )}
        </>
      )}
      {/* <Footer/> */}
    </Box>
  )
}

export default VenueDashboard
